function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_488",
  "data-name": "Group 488",
  transform: "translate(-35 -302)"
}, React.createElement("g", {
  id: "Ellipse_8",
  "data-name": "Ellipse 8",
  transform: "translate(35 302)",
  fill: "none",
  stroke: "#11131a",
  strokeWidth: 0.5
}, React.createElement("circle", {
  cx: 5.5,
  cy: 5.5,
  r: 5.5,
  stroke: "none"
}), React.createElement("circle", {
  cx: 5.5,
  cy: 5.5,
  r: 5.25,
  fill: "none"
})), React.createElement("g", {
  id: "surface1",
  transform: "translate(38.144 305.143)"
}, React.createElement("path", {
  id: "Path_85",
  "data-name": "Path 85",
  d: "M10.45,8.623a.254.254,0,0,0-.206.119L7.857,12.394,6.311,11.057a.254.254,0,1,0-.333.381l1.768,1.53a.253.253,0,0,0,.377-.056L10.672,9.02a.254.254,0,0,0-.222-.4Z",
  transform: "translate(-5.874 -8.623)"
})));

var SvgChecked2 = function SvgChecked2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChecked2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checked2.442ef4ba.svg";
export { ForwardRef as ReactComponent };